import { useEffect, useState } from 'react';
import './index.scss';
import ErrorIndex from '@/components/ErrorIndex';
import { useParams } from 'react-router-dom';
import { setDocumentTitle } from '@/utils';
import { isEnv } from '@/utils';
import dayjs from 'dayjs';
interface ErrorIndex {
  errorTitle?: string; // 标题
  errorInfo?: unknown;
  imgChild: unknown; //图片
  clicButton?: unknown;
}

// 活动领取状态
const ACTIVITY_UN_START = 601; // 活动未开始
const ACTIVITY_IS_END = 602; // 活动已结束
const ACTIVITY_UNABLE = 603; // 已领完
const ACTIVITY_REPEAT = 605; // 重复参与
const Index = () => {
  const [errorIndex, setErrorIndex] = useState<ErrorIndex>();
  const [activity, setActivity] = useState<any>();
  const [startTime, setStartTime] = useState<number>();
  const param = useParams();

  useEffect(() => {
    const activity = sessionStorage.getItem('couponInfo');
    if (activity) {
      const newActivity = JSON.parse(activity);
      setDocumentTitle(newActivity?.activityName);
      setActivity(newActivity);
      setStartTime(newActivity?.startTime);
    }
    setStatus();
  }, [startTime]);
  const setStatus = () => {
    console.log('...', param);
    const errorTitle: any = activity?.activityName; // 标题;
    let errorInfo = '';
    let img: any;
    let goWechatText: any;
    switch (Number(param.id)) {
      case ACTIVITY_UN_START:
        errorInfo = `活动将在${
          startTime ? dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') : ''
        }开始，敬请期待～`;
        img = (
          <img
            src={require('@/images/common/not_started.png')}
            alt="未开始"
            className="error-img"
          />
        );
        goWechatText = '进入海底捞外送小程序查看更多优惠活动';
        break;
      case ACTIVITY_IS_END:
        errorInfo = '活动已结束，感谢您的关注～';
        img = (
          <img
            src={require('@/images/common/over.png')}
            alt="活动已结束"
            className="error-img"
          />
        );
        goWechatText = '进入海底捞外送小程序查看更多优惠活动';
        break;
      case ACTIVITY_REPEAT:
        errorInfo = '已领取到券包，不能再领啦~';
        img = (
          <img
            src={require('@/images/common/has_get.png')}
            alt="已领取到券包"
            className="error-img"
          />
        );
        goWechatText = '进入海底捞外送小程序查看券包';
        break;
      case ACTIVITY_UNABLE:
        errorInfo = '券被领完了，下次要早点来哦～';
        img = (
          <img
            src={require('@/images/common/coupon_empty.png')}
            alt="券被领完了"
            className="error-img"
          />
        );
        goWechatText = '进入海底捞外送小程序查看更多优惠活动';
        break;
      default:
        break;
    }
    const errorIndex: any = {
      errorTitle: errorTitle, // 标题
      errorInfo: errorInfo,
      imgChild: img, //图片
      clicButton: (
        <>
          {isEnv() === 'WxChat' ? (
            <div className="clic-Button">
              <span>{goWechatText}</span>
            </div>
          ) : null}
        </>
      ),
    };

    setErrorIndex(errorIndex);
  };
  return (
    <div className="coupon-Error">
      <ErrorIndex
        imgChild={errorIndex?.imgChild}
        title={errorIndex?.errorTitle}
        info={errorIndex?.errorInfo}
        clicButton={errorIndex?.clicButton}
      ></ErrorIndex>
    </div>
  );
};

export default Index;
